.action-menu-container > *:first-child {
    padding: 0 8px;
}

.margin-left {
    margin-left: 8px;
}
